import create from './createAction'

export const GET_FORM_SETTINGS = 'GET_FORM_SETTINGS'
export const SET_FORM_SETTINGS = 'SET_FORM_SETTINGS'
export const GET_FORM_SETTINGS_ERROR = 'GET_FORM_SETTINGS_ERROR'
export const SET_FORM_SUBDOMAIN = 'SET_FORM_SUBDOMAIN'
export const RESET_INSURANCE = 'RESET_INSURANCE'
export const getFormSettings = create(GET_FORM_SETTINGS)
export const setFormSettings = create(SET_FORM_SETTINGS)
export const getFormSettingsError = create(GET_FORM_SETTINGS_ERROR)
export const setFormSubdomain = create(SET_FORM_SUBDOMAIN)
export const resetInsurance = create(RESET_INSURANCE)
